import isEqual from 'lodash/fp/isEqual';

export default function watchParamsForStore(store) {
  return function (actionCreator) {
    return {
      onEnter(next) {
        dispatch(next);
      },
      onChange(prev, next) {
        if (!isEqual(prev, next)) {
          dispatch(next);
        }
      },
    };

    function dispatch(next) {
      const params = Object.assign({}, next.params, (next.location || {}).query);
      store.dispatch(actionCreator(params));
    }
  };
}
